import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useWallet } from '../context/WalletContext';
import { useUserData } from '../hooks/useUserData';
import { Spinner, PageLoader } from '../components/common/Loader';
import NetworkGuard from '../components/common/NetworkGuard';
import WithdrawForm from '../components/withdraw/WithdrawForm';

export default function WithdrawPage() {
  const { isConnected, connect, connecting } = useWallet();
  const { user, refresh, isRegistered, loading } = useUserData();
  const navigate = useNavigate();

  if (!isConnected) {
    return (
      <div className="container withdraw-page">
        <div className="empty-state">
          <div className="icon">🔒</div>
          <h3 style={{ marginBottom: 8 }}>Connect Your Wallet</h3>
          <button className="btn btn-primary btn-lg mt-4" onClick={connect} disabled={connecting}>
            {connecting ? <><Spinner /> Connecting</> : 'Connect Wallet'}
          </button>
        </div>
      </div>
    );
  }

  return (
    <NetworkGuard>
      <div className="container withdraw-page">
        {loading ? (
          <PageLoader label="LOADING" sub="Preparing withdrawal..." />
        ) : !isRegistered ? (
          <div className="empty-state">
            <div className="icon">📝</div>
            <h3 style={{ marginBottom: 8 }}>Please Register First</h3>
            <button className="btn btn-primary btn-lg mt-4" onClick={() => navigate('/register')}>
              Register Now →
            </button>
          </div>
        ) : (
          <WithdrawForm user={user} onDone={refresh} />
        )}
      </div>
    </NetworkGuard>
  );
}
